import React from 'react';
import styled from 'styled-components';

const HotelImageWrap = ({hotelImage}) => (
  <HotelImageWrapDiv>
    <HotelGalleryImage src={hotelImage} alt="Segment Image" />
    <ImageTextWrapper><span>Room Image</span></ImageTextWrapper>
  </HotelImageWrapDiv>
);

export default HotelImageWrap;

const HotelImageWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 14rem;
    height: 14rem;
    position: relative;
  `,
);

const HotelGalleryImage = styled.img(
  props => `
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.base};
    object-fit: fill;
    width: 14rem;
    height: 14rem;
`,
);

export const ImageTextWrapper = styled.div(
  props => `
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    color: ${props.theme.colors.white.base};
    background: ${props.theme.colors.black.base};
    padding: ${props.theme.spacing.small.s3};
    border-radius: 0 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    font-size: ${props.theme.font.small.font10};
    justify-content: center;
  `
);
